import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import Helpers from "../Helper/Helpers";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const Products = () => {
  const [productData, setProductData] = useState({
    name: "",
    category: "",
    subcategory: "",
    price: "",
    description: "",
    quantity: 1,
    features: [""],
    specifications: [""],
    details: [""],
  });

  const [allCategory, setAllCategory] = useState([]);
  const [allSubCategory, setAllSubCategory] = useState([]);
  const [images, setImages] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    FetchAllCategory();
  }, []);

  const FetchAllCategory = async () => {
    try {
      const res = await Helpers("/admin/category/get", "GET");
      if (res && res.status) {
        setAllCategory(res.data.reverse());
      }
    } catch (error) {
      console.log(error);
    }
  };

  const FetchAllSubCategory = async (categoryId) => {
    try {
      const res = await Helpers(
        `/admin/subcategory/by-category/${categoryId}`,
        "GET"
      );
      if (res && res.status) {
        setAllSubCategory(res.data.reverse());
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setProductData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === "category") {
      setProductData((prevData) => ({
        ...prevData,
        subcategory: "", // reset subcategory when category changes
      }));
      FetchAllSubCategory(value);
    }
  };

  const handleAddField = (field) => {
    setProductData((prevData) => ({
      ...prevData,
      [field]: [...prevData[field], ""],
    }));
  };

  const handleRemoveField = (field, index) => {
    const updatedArray = productData[field].filter((_, i) => i !== index);
    setProductData((prevData) => ({
      ...prevData,
      [field]: updatedArray,
    }));
  };

  const handleFieldChange = (e, field, index) => {
    const { value } = e.target;
    const updatedArray = [...productData[field]];
    updatedArray[index] = value;
    setProductData((prevData) => ({
      ...prevData,
      [field]: updatedArray,
    }));
  };

  const HandleImage = async (e) => {
    let files = e.target.files;
    if (!files || files.length === 0) {
      toast.error("Please select files.");
      return;
    }

    const validImageTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
    ];
    const uploadedImages = [];

    // Loop through the selected files and check their validity
    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      if (!validImageTypes.includes(file.type)) {
        toast.error("Only images (jpeg, jpg, png, gif) are allowed.");
        return;
      }

      const data = new FormData();
      data.append("image", file);

      try {
        const response = await fetch(
          "http://3.111.171.1:8001/api/v1/upload-image",
          {
            method: "POST",
            body: data,
          }
        );

        if (!response.ok) {
          toast.error("Failed to upload image");
          return;
        }

        const res = await response.json();

        if (res?.url) {
          uploadedImages.push(res.url); // Collecting URLs of uploaded images
        } else {
          toast.error("Failed to get image URL.");
        }
      } catch (error) {
        console.error("Upload Error:", error);
        toast.error(error.message || "An error occurred while uploading.");
      }
    }

    // Once all files are uploaded, update the state with all URLs
    if (uploadedImages.length > 0) {
      setImages((prevImages) => [...prevImages, ...uploadedImages]);
    }
  };

  const handleRemoveImage = (index) => {
    const updatedImages = productData.images.filter((_, i) => i !== index);
    setProductData((prevData) => ({
      ...prevData,
      images: updatedImages,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const {
      name,
      category,
      subcategory,
      price,
      description,
      quantity,
      features,
      specifications,
      details,
    } = productData;

    console.log("hgjhdfgjdfg", productData, images);

    if (!name || !category || !subcategory || !price || !description) {
      toast.error("All fields are required.");
      return;
    }

    try {
      const res = await Helpers("/admin/product/add", "POST", {
        name,
        category,
        subcategory,
        price,
        description,
        quantity,
        features,
        specifications,
        details,
        images: images,
      });

      if (res && res.status) {
        toast.success("Product Added Successfully.");
        navigate("/admin/product");
        setProductData({
          name: "",
          category: "",
          subcategory: "",
          price: "",
          description: "",
          quantity: 1,
          features: [""],
          specifications: [""],
          details: [""],
        });
        setImages([]);
      } else {
        toast.error("Failed to add product.");
      }
    } catch (error) {
      toast.error("An error occurred while adding the product.");
    }
  };

  return (
    <div className="p-8 mt-14">
      <h1 className="text-3xl font-bold mb-8">Add Product</h1>
      <form onSubmit={handleSubmit}>
        {/* Input Fields */}
        {[
          { label: "Product Name", name: "name", type: "text" },
          { label: "Price", name: "price", type: "number" },
        ].map((input) => (
          <div className="mb-4" key={input.name}>
            <label className="block text-sm font-medium text-gray-700">
              {input.label}
            </label>
            <input
              type={input.type}
              name={input.name}
              value={productData[input.name]}
              onChange={handleChange}
              className="border p-2 rounded w-full"
              placeholder={input.label}
            />
          </div>
        ))}

        {/* Description */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            Description
          </label>
          <textarea
            name="description"
            value={productData.description}
            onChange={handleChange}
            className="border p-2 rounded w-full"
            placeholder="Description"
          />
        </div>

        {/* Category */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            Category
          </label>
          <select
            name="category"
            value={productData.category}
            onChange={handleChange}
            className="border p-2 rounded w-full"
          >
            <option value="">Select Category</option>
            {allCategory.map((ele) => (
              <option key={ele._id} value={ele._id}>
                {ele.name}
              </option>
            ))}
          </select>
        </div>

        {/* Subcategory */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            Subcategory
          </label>
          <select
            name="subcategory"
            value={productData.subcategory}
            onChange={handleChange}
            className="border p-2 rounded w-full"
          >
            <option value="">Select Subcategory</option>
            {allSubCategory.map((ele) => (
              <option key={ele._id} value={ele._id}>
                {ele.name}
              </option>
            ))}
          </select>
        </div>

        {/* Repeating Fields */}
        {["features", "specifications", "details"].map((field) => (
          <div className="mb-4" key={field}>
            <label className="block text-sm font-medium text-gray-700">
              {field.charAt(0).toUpperCase() + field.slice(1)}
            </label>
            {productData[field].map((value, index) => (
              <div key={index} className="flex gap-2 mb-2">
                <input
                  type="text"
                  value={value}
                  onChange={(e) => handleFieldChange(e, field, index)}
                  className="border p-2 rounded w-full"
                  placeholder={field}
                />
                <button
                  type="button"
                  onClick={() => handleRemoveField(field, index)}
                  className="bg-red-500 text-white px-2 py-1 rounded"
                >
                  Remove
                </button>
              </div>
            ))}
            <button
              type="button"
              onClick={() => handleAddField(field)}
              className="bg-blue-500 text-white px-3 py-1 rounded"
            >
              Add {field}
            </button>
          </div>
        ))}

        {/* Image Upload */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            Upload Images
          </label>
          <input
            type="file"
            multiple
            accept="image/*"
            onChange={HandleImage}
            className="border p-2 rounded w-full"
          />
          <div className="flex flex-wrap gap-4 mt-2">
            <div className="flex flex-wrap gap-4 mt-2">
              {images.map((img, index) => (
                <div key={index} className="relative">
                  <img
                    src={img}
                    // alt={`Uploaded Image ${index}`}
                    className="w-24 h-24 object-cover rounded"
                  />
                  <button
                    type="button"
                    onClick={() => {
                      setImages((prevImages) =>
                        prevImages.filter((_, i) => i !== index)
                      );
                    }}
                    className="absolute top-0 right-0 bg-red-500 text-white rounded px-1"
                  >
                    x
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Submit */}
        <button
          type="submit"
          className="bg-green-500 text-white px-4 py-2 rounded"
        >
          Add Product
        </button>
      </form>
    </div>
  );
};

export default Products;
